import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Illustration,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { type PlacementDetail } from "../api/useGetPlacement";
import { BrowseMoreJobsButton } from "./BrowseMoreJobsButton";

interface PlacementApplicationSuccessBottomSheetProps {
  modalState: UseModalState;
  placementDetails: PlacementDetail;
}

export function PlacementApplicationSuccessBottomSheet(
  props: PlacementApplicationSuccessBottomSheetProps
) {
  const { modalState, placementDetails } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          <BrowseMoreJobsButton />
        </DialogFooter>
      }
    >
      <Box sx={{ py: 8 }}>
        {placementDetails.status === "open" && (
          <Stack spacing={8} alignItems="center" justifyContent="center">
            <Illustration type="request-sent" />
            <Stack spacing={2}>
              <Text variant="h3" textAlign="center" sx={{ fontSize: "2.5rem" }}>
                Application
              </Text>
              <Text variant="h3" textAlign="center" sx={{ fontSize: "2.5rem" }}>
                sent!
              </Text>
            </Stack>
          </Stack>
        )}
        {placementDetails.status === "waitlist" && (
          <BottomSheetIllustrationContent
            title="Thank you for joining the waitlist"
            illustrationType="clock"
            description="You were placed on a waitlist because this job is not currently open. As soon as it becomes open, you'll be invited for an interview."
          />
        )}
      </Box>
    </BottomSheet>
  );
}
